import Controller from "controllers/application_controller"

const MAX_VISIBLE_OPTIONS = 8

export default class extends Controller {
  static identifier = 'ui-form-multiselect'
  static targets = ['search', 'option', 'list', 'count', 'clear']
  static values = {
    summarySingularLabel: { type: String, default: 'option' },
    summaryPluralLabel: { type: String, default: 'options' }
  }

  connect() {
    this.sizeList()
    this.updateCount()
  }

  filter() {
    let query = this.searchTarget.value.toLowerCase()

    this.optionTargets.forEach(option => {
      let text = option.textContent.toLowerCase()
      option.hidden = query && !text.includes(query)
    })

    this.updateCount()
  }

  updateCount() {
    if (!this.hasCountTarget) return

    let count = this.#checkedCount()
    if (count > 0) {
      this.countTarget.textContent = `${count} selected`
      this.clearTarget.hidden = false
    } else {
      let visibleCount = this.#visibleOptionsCount()
      this.countTarget.textContent = `Showing ${visibleCount} ${this.#summaryLabel(visibleCount)}`
      this.clearTarget.hidden = true
    }
  }

  clearAll(event) {
    event.preventDefault()

    this.optionTargets.forEach(option => {
      option.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        cb.checked = false
      })
    })

    this.updateCount()
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }

  sizeList() {
    if (!this.hasListTarget || !this.optionTargets.length) return

    let optionHeight = this.optionTargets[0].offsetHeight
    if (optionHeight === 0) return

    let visibleCount = Math.min(this.optionTargets.length, MAX_VISIBLE_OPTIONS)
    this.listTarget.style.height = `${optionHeight * visibleCount}px`
  }

  #checkedCount() {
    return this.element.querySelectorAll('.ui-form-multiselect__option input[type="checkbox"]:checked').length
  }

  #visibleOptionsCount() {
    return this.optionTargets.filter(option => !option.hidden).length
  }

  #summaryLabel(count) {
    if (count === 1) return this.summarySingularLabelValue

    return this.summaryPluralLabelValue
  }
}
